<template>
  <v-responsive class="overflow-y-auto" :max-height="$store.state.maxHeight">
  <v-container>
    <v-hover v-slot:default="{ hover }">
      <v-card
        class="mx-auto"
        color="grey lighten-4"
      >
        <v-img
          :aspect-ratio="16/9"
          src="../../../static/course/course_banner.jpg"
        >
          <v-expand-transition>
            <div
              v-if="hover && !$vuetify.breakpoint.xs"
              class="d-flex transition-fast-in-fast-out blue darken-2 v-card--reveal display-3 white--text"
              style="height: 100%;"
            >
              Java核心编程技术 Core Java
            </div>
            <div
              v-if="hover && $vuetify.breakpoint.xs"
              class="d-flex transition-fast-in-fast-out blue darken-2 v-card--reveal display-3 white--text"
              style="height: 100%;font-size:2em !important;"
            >
              Java核心编程技术 Core Java
            </div>
          </v-expand-transition>
        </v-img>
        <v-card-text
          class="pt-6"
          style="position: relative;"
        >
          <v-btn
            absolute
            color="blue"
            class="white--text"
            fab
            large
            right
            top
          >
            <v-icon>mdi-party-popper</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-hover>
    <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
      <v-timeline-item
        v-for="(item, i) in items"
        :key="i"
        :color="item.color"
        :icon="item.icon"
        fill-dot
      >
        <v-card
          :color="item.color"
          dark
        >
          <v-card-title class="title">{{ item.title }}</v-card-title>
          <v-card-text v-html="item.simpleDesc">
          </v-card-text>
        </v-card>
<!--          <v-expansion-panels>-->
<!--            <v-expansion-panel-->
<!--            >-->
<!--              <v-expansion-panel-header>详情</v-expansion-panel-header>-->
<!--              <v-expansion-panel-content v-html="item.details" style="margin: 0px 10px 20px 20px">-->
<!--              </v-expansion-panel-content>-->
<!--            </v-expansion-panel>-->
<!--          </v-expansion-panels>-->
      </v-timeline-item>
    </v-timeline>
  </v-container>
</v-responsive>
</template>
<style>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
</style>
<script>


  export default {
    data () {
      return {
        dialog: false,
        items:[
  {
    "color": "red lighten-2",
    "icon": "mdi-star",
    "title": "Core Java",
    "simpleDesc": "掌握Java语法、面向对象编程思想，覆盖Java SE核心技术（集合、线程、IO、反射等），包含JDK 8及以上新特性，聚焦企业级编码逻辑与问题解决。"
  },
  {
    "color": "indigo",
    "icon": "mdi-buffer",
    "title": "OOP",
    "simpleDesc": "深入理解面向对象三大特征（封装、继承、多态），掌握类、对象、接口、抽象类等核心概念，结合单例模式等设计模式与实际项目（记账本系统）强化应用。"
  },
  {
    "color": "purple darken-1",
    "icon": "mdi-book-variant",
    "title": "Oracle/MySQL",
    "simpleDesc": "熟练掌握ORACLE和MySQL安装配置、增删改查、多表查询、事务、索引、存储过程等核心操作，适配中小型企业级数据库开发需求。"
  },
  {
    "color": "green lighten-1",
    "icon": "mdi-fedora",
    "title": "JDBC",
    "simpleDesc": "理解JDBC核心API与数据库交互原理，掌握连接池、PreparedStatement、事务控制，封装DBUtils组件，结合学生信息管理系统实现CRUD实战。"
  },
  {
    "color": "deep-orange darken-1",
    "icon": "mdi-airballoon",
    "title": "XML",
    "simpleDesc": "掌握XML文档结构与解析方式（DOM4J），了解XML在数据交换、配置中的应用，结合POI实现百万数据读写实战。"
  },
  {
    "color": "brown darken-1",
    "icon": "mdi-rotate-orbit",
    "title": "MyBatis/MyBatis-Plus",
    "simpleDesc": "精通MyBatis核心配置、Mapper映射、动态SQL、多表关联查询，掌握MyBatis-Plus通用Mapper、条件构造器、分页插件，提升持久层开发效率。"
  },
  {
    "color": "green accent-3",
    "icon": "mdi-library",
    "title": "HTML CSS JS(ES6+)",
    "simpleDesc": "掌握HTML5表单与语义化标签、CSS3布局（弹性盒、浮动）、ES6+语法，实现动态表格与表单验证，为前端开发奠定基础。"
  },
  {
    "color": "orange lighten-1",
    "icon": "mdi-lightbulb-cfl",
    "title": "Servlet",
    "simpleDesc": "理解Servlet生命周期与HTTP协议交互，掌握Request/Response处理、请求转发与重定向、会话跟踪，结合JDBC实现Web版学生管理系统。"
  },
  {
    "color": "light-blue accent-3",
    "icon": "mdi-ethereum",
    "title": "Java Web基础",
    "simpleDesc": "掌握Tomcat部署、JSP语法、EL表达式、JSTL标签库，理解B/S架构与动态资源开发，结合Servlet实现企业级Web应用基础功能。"
  },
  {
    "color": "pink accent-3",
    "icon": "mdi-brightness-5",
    "title": "Spring 6.2",
    "simpleDesc": "深入理解IOC、AOP核心思想，掌握Bean配置（XML/注解/Java Config）、生命周期、事务管理，手写Spring IOC强化原理认知，适配企业级开发规范。"
  },
  {
    "color": "lime darken-2",
    "icon": "mdi-wan",
    "title": "Ajax Axios",
    "simpleDesc": "掌握Promise、Async/Await异步编程，使用Axios封装请求，解决跨域与响应处理问题，结合Vue实现动态数据渲染与表单提交。"
  },
  {
    "color": "light-green lighten-1",
    "icon": "mdi-wallet-membership",
    "title": "Vue3.5 ElementPlus",
    "simpleDesc": "精通Vue3选项式与组合式API、路由（VueRouter4）、状态管理（Pinia），熟练使用ElementPlus组件，完成用户管理系统、影院购票平台等实战项目。"
  },
  {
    "color": "green lighten-1",
    "icon": "mdi-registered-trademark",
    "title": "Spring Boot 3.5",
    "simpleDesc": "掌握Spring Boot自动配置、Starter原理，整合MyBatis、Redis、消息中间件等，实现热部署与健康检查，快速开发微服务基础应用。"
  },
  {
    "color": "teal lighten-1",
    "icon": "mdi-kodi",
    "title": "PL/SQL",
    "simpleDesc": "学习Oracle PL/SQL程序结构、游标、触发器、存储过程与函数，掌握复杂查询与数据处理技巧，适配数据库高级应用场景。"
  },
  {
    "color": "cyan lighten-2",
    "icon": "mdi-quora",
    "title": "Git",
    "simpleDesc": "掌握Git版本控制核心操作（分支管理、提交、合并、冲突解决），熟悉GitHub/GitLab协同开发流程，结合IDE实现项目版本管理。"
  },
  {
    "color": "light-blue lighten-2",
    "icon": "mdi-island",
    "title": "Socket网络编程",
    "simpleDesc": "理解TCP/UDP协议，掌握Socket服务端与客户端开发，实现网络资源获取与数据传输，完成易途点餐系统等实战项目。"
  },
  {
    "color": "deep-purple darken-1",
    "icon": "mdi-invert-colors",
    "title": "Spring Cloud 2025",
    "simpleDesc": "掌握微服务架构核心组件（Nacos注册/配置中心、Sentinel限流熔断、Gateway网关），实现服务调用、负载均衡与分布式事务处理。"
  },
  {
    "color": "indigo darken-1",
    "icon": "mdi-image-filter-vintage",
    "title": "消息中间件(RabbitMQ)",
    "simpleDesc": "理解AMQP协议，掌握RabbitMQ交换机类型、死信队列、延迟队列，实现异步通信与超时订单自动取消等实战场景。"
  },
  {
    "color": "blue lighten-1",
    "icon": "mdi-vanish",
    "title": "Linux - RockyLinux",
    "simpleDesc": "掌握Linux系统安装、文件权限、命令操作，配置YUM源与网络，实现JDK、Tomcat、MySQL等软件部署，适配服务器运维需求。"
  },
  {
    "color": "purple darken-1",
    "icon": "mdi-domino-mask",
    "title": "Redis",
    "simpleDesc": "精通Redis数据类型、持久化（RDB/AOF）、主从复制、集群配置，掌握缓存穿透/击穿解决方案，实现排行榜、点赞等实战功能。"
  },
  {
    "color": "red lighten-1",
    "icon": "mdi-plus-thick",
    "title": "Quartz",
    "simpleDesc": "掌握Quartz核心API与Cron表达式，实现定时任务调度、集群部署，结合Spring Task适配项目中作业调度需求。"
  },
  {
    "color": "pink lighten-2",
    "icon": "mdi-bell-circle",
    "title": "Maven",
    "simpleDesc": "掌握Maven项目构建、依赖管理、仓库配置，理解POM文件与继承聚合特性，结合IDE实现项目打包与私服交互。"
  },
  {
    "color": "grey darken-3",
    "icon": "mdi-diamond-stone",
    "title": "Docker",
    "simpleDesc": "理解Docker容器化原理，掌握镜像/容器操作、Dockerfile编写、Compose编排，实现微服务项目与中间件集群部署。"
  },
  {
    "color": "amber darken-1",
    "icon": "mdi-brain",
    "title": "Spring AI",
    "simpleDesc": "掌握Spring AI核心组件（ChatClient、Prompt工程），实现本地模型部署（Ollama）、RAG检索增强、多模态交互与Tool Calling。"
  },
  {
    "color": "teal darken-2",
    "icon": "mdi-database-search",
    "title": "生产级RAG实战",
    "simpleDesc": "精通RAG架构设计、向量数据库应用、检索优化与重排序，实现NL2SQL与企业级智能问答系统开发，掌握容器化部署方案。"
  },
  {
    "color": "indigo lighten-1",
    "icon": "mdi-code-braces",
    "title": "AI工具应用",
    "simpleDesc": "熟悉Cursor、Copilot等AI开发工具，掌握API Key配置与本地模型部署，利用AI提升代码开发效率与工程质量。"
  },
  {
    "color": "rose darken-1",
    "icon": "mdi-project-management",
    "title": "模拟工作环境项目实战",
    "simpleDesc": "整合全栈技术（Vue3+Spring Cloud+Redis+Docker），采用前后端分离与微服务架构，完成真实环境系统开发与部署。"
  }
],
        // items: [
        //   {
        //     color: 'red lighten-2',
        //     icon: 'mdi-star',
        //     title: 'Core Java',
        //     simpleDesc: 'Java语法，面向对象编程思想，Java SE 8.0平台开发，集合，10,多线程并发模式，Socket, 基于多种协议的网络原理及应用开发，Annotation标注技术的高级编程技巧，泛型技术。<br/>掌握核心Java重点、难点及编程中常见问题，强调面向对象的思想解决问题，同时新的JDK8.0重要特性让你把握未来软件的开发潮流。',
        //   },
        //   {
        //     color: 'indigo',
        //     icon: 'mdi-buffer',
        //     title: 'OOAD/UML',
        //     simpleDesc: '从实际企业项目出发学习面向对象(OO)的分析与设计(OOAD),包括统一建模语言(UML)和关联的概念统软件过程(UP)，Rational Rose/Trufun/XDE的使用，深入总结面向对象分析设计理论及应用技巧。<br/>掌握面向对象的设计方法、技巧及工具Rational Rose/Trufun;掌握统一软件开发过程(RSDP)，通用软件职责分配模式(GRASP)和GOF下常用设计模式的应用。',
        //   },
        //   {
        //     color: 'purple darken-1',
        //     icon: 'mdi-book-variant',
        //     title: 'Oracle',
        //     simpleDesc: 'Oracle的基本原理，以Oracle为平台 ,讲解数据定义语言(DDL)、数据操作语言(DML)、 数据控制语言(DCL),多表连接查询，事务、以及视图索引序列等。<br/>掌握Oracle应用技术:正确创建表，索引及约束，并能完成较为复杂的多表查询。',
        //   },
        //   {
        //     color: 'green lighten-1',
        //     icon: 'mdi-fedora',
        //     title: 'JDBC',
        //     simpleDesc: 'JDBC2.0技术，事务管理，批处理，可滚动、可更新的结果集、对象标识分配策略(OID),对象关系映射(ORM)技术，设计多层数据库应用程序。掌握JDBC编程技术;<br/>掌握分页查询技巧;对象关系映射原理及编程实现;使用DAO编程模式编写高性能的数据持久层应用。',
        //   },
        //   {
        //     color: 'deep-orange darken-1',
        //     icon: 'mdi-airballoon',
        //     title: 'XML',
        //     simpleDesc: '掌握可扩展的标记语言(xml)的文档结构、模式定义(DTD、Schema);掌握JAVA解析XML文档的API(SAX和DOM),以及使用第三方工具DOM4J和JDOM解析XML文档;理解XML在数据交换、数据持久化、系统配置等方面的应用。<br/>正确定义和编写XML文档，并使用多种方式解析生成XML文档，理解XML是对象序列化的一种重要机制，掌握XML应用程序开发所必须的基础知识。',
        //   },
        //   {
        //     color: 'brown darken-1',
        //     icon: 'mdi-rotate-orbit',
        //     title: 'MyBatis',
        //     simpleDesc: 'MyBatis的基本概念，应用场景; MyBatis的核心 API介绍，MyBatis的基本原理，基于MyBatis的 CRUD操作，MyBatis的多种查询方式，多表链接，Mapper映射，MyBatis的扩展属性介绍,MyBatis 的代码生成器。<br/>熟练掌握基于MyBatis的持久化操作和DAO编程模式，使用XML完成对象到关系数据库的映射，熟练掌握MyBatis的多表关联技术。',
        //   },
        //   {
        //     color: 'green accent-3',
        //     icon: 'mdi-library',
        //     title: 'Html JS(ES6) CSS',
        //     simpleDesc: 'HTML的基本标签使用，JS基本语法介绍，程序控制结构，JS内置的基本对象，JS调用DHTML元素，JS编写客户端脚本程序，讲解WEB页面访问和开发的基本过程。<br/>掌握基本的HTML标签,使用HTML/CSS开发静态网页，使用JS完成表单验证，实现WEB页面的动态效果，掌握JS编写客户端脚本程序，创建功能强大的互动页面。',
        //   },
        //   {
        //     color: 'orange lighten-1',
        //     icon: 'mdi-lightbulb-cfl',
        //     title: 'Servlet',
        //     simpleDesc: '掌握Servlet2.4版本内容，开发部署方法，生命周期管理。Servlet常用类及接口的使用，以及WEB应用中的高级资源访问。以Tomcat为环境，基于MVC模式学习Servlet/filter/listener等技术，快速建立WEB应用，深入讲授Servlet在大型企业应用中扮演的角色及设计技巧。<br/>掌握Servlet2.4规范技术，熟练掌握Servlet的开发及部署，能够独立分析设计基于N层体系结构的WEB应用，创建基于MVC模式的应用。',
        //   },
        //   {
        //     color: 'light-blue accent-3',
        //     icon: 'mdi-ethereum',
        //     title: 'JSP',
        //     simpleDesc: '创建部署和运行JSP，JSP中使用JAVABean，处理异常，自定义标签，JSTL标签库，表达式语言(EL)。<br/>掌握JSP2.0规范技术，包括开发和部署JSP，使用JSP、JAVABEAN、EL、JSTL创建WEB应用，最后结合Servlet技术完成WEB应用的开发。',
        //   },
        //   {
        //     color: 'pink accent-3',
        //     icon: 'mdi-brightness-5',
        //     title: 'Struts2.5',
        //     simpleDesc: '重点讲解基于MVC设计模式的开源框架Struts原理，Struts的基本开发流程，高级特性，Struts标签的使用以及Validation框架。<br/>深入理解MVC模式，熟练掌握基于Struts的JavaEE解决方案。',
        //   },
        //   {
        //     color: 'lime darken-2',
        //     icon: 'mdi-wan',
        //     title: 'Ajax Jquery1.4',
        //     simpleDesc: '全面讲解AJAX原理，常用数据传递方式(字符串、XML及JSON)，讲解AJAX最新版本开源框架Dojo和DWR的使用以及优秀的JavaScript框架jQuery。<br/>深入理解AJAX基本原理，创建更加灵活的WEB应用。',
        //   },
        //   {
        //     color: 'light-green lighten-1',
        //     icon: 'mdi-wallet-membership',
        //     title: 'Vue Element-UI',
        //     simpleDesc: '全面讲解Vue基本指令元素、函数、计算属性、双向绑定、过滤器、自定义指令元素，ToDoMVC框架，Vue-component(vue组件),Webpack,SPA,组件间的通讯，Vue生命周期，axios插件，以及Vue-Router(路由),Element-UI基本组件的使用。<br/>掌握vue各种基本指令元素、函数、计算属性、双向绑定、过滤器、自定义指令元素的使用，使用Vue插件发送异步请求，使用axios组件异步处理，掌握路由常用属性,嵌套路由路由组件传递数据，Element-UI基本组件的使用。',
        //   },
        //   {
        //     color: 'green lighten-1',
        //     icon: 'mdi-registered-trademark',
        //     title: 'Spring4.0',
        //     simpleDesc: '全面讲解Spring原理，安装和构建Spring,全面讲解Spring中Bean工厂,依赖注入，控制反转，面向切面的编程，SpringMVC的概念、原理、执行流程、参数传递、参数校验、异常处理、拦截器等，全面讲解SpringMVC对RestFul的支持，在老师的带领下手写Spring框架。<br/>掌握Spring框架的使用，了解Spring的编程思想，掌握面向接口编程的重要性,熟悉模板和回调等编程设计模式，使用Spring构建JAVAEE轻量级Bean的解决方案。',
        //   },
        //   {
        //     color: 'teal lighten-1',
        //     icon: 'mdi-kodi',
        //     title: 'PL/SQL',
        //     simpleDesc: '深入学习PL/SQL内容:程序结构、变量与数据类型、控制语句、游标、触发器、过程和函数，掌握SQL和PL/SQL的应用及编程。<br/>熟练掌握PL/SQL的基本程序结构 ，基本的数据类型，控制流程， 游标的应用，完成较为复杂的查询。',
        //   },
        //   {
        //     color: 'cyan lighten-2',
        //     icon: 'mdi-quora',
        //     title: 'Git',
        //     simpleDesc: '主要讲解CVS (版本控制工具)发展，详细讲解分布式版本控制工具Git在企业中的应用，包括Git的安装配置、Git命令行操作、Git的三 大区域、版本回退撤销等操作、分支管理、标签管理远程仓库、工作流。GitHub注册与配置，如何使用GitHub进行协同开发，如何为开源项目贡献代码。详细讲解在IDE (IDEA/Eclipse) 中如何使用Git进行版本管理。<br/>熟练掌握Git的安装配置、三大区域、版本回退撤销等操作、分支管理、标签管理、远程仓库、工作流。使用GitHub进行协同开发，如何为开源项目贡献代码。',
        //   },
        //   {
        //     color: 'light-blue lighten-2',
        //     icon: 'mdi-island',
        //     title: 'webService',
        //     simpleDesc: 'XML Name Space:Schema技术；使用JAXP技术对XML文档进行解析，搭建基本的webservice应用程序，使用JAX-RPC和JAX-WS开发webservice项目。全面讲解使用Apache WebService框架CXF开发WebService项目。<br/>掌握webservice的运行原理，具备开发webservice项目的能力。',
        //   },
        //   {
        //     color: 'deep-purple darken-1',
        //     icon: 'mdi-invert-colors',
        //     title: 'Dubbo',
        //     simpleDesc: '详细讲解系统架构的演变、微服务概念以及RPC原理，Zookeeper的安装(单机版、集群版)以及其作为Dubbo注册中心的使用。详解Dubbo对微服务的治理，集群群容错机制，负载均衡策略，服务降级方式(详细讲解如何使用Hystrix框架进行服务降级、服务熔断等)，服务限流等微服务常用术。<br/>理解微服务概念，能够使用Dubbo开发微服务。',
        //   },
        //   {
        //     color: 'indigo darken-1',
        //     icon: 'mdi-image-filter-vintage',
        //     title: 'ActiveMQ',
        //     simpleDesc: '详细讲解JMS (Java Message Service)标准、JMS核心API、点对点和发布订阅两种消息类型。详解MQ消息类型、ActiveMQ的安全控制方式、ActiveMQ持久化的几种方式。<br/>掌握使用ActiveMQ进行异步编程方式。',
        //   },
        //   {
        //     color: 'blue lighten-1',
        //     icon: 'mdi-vanish',
        //     title: 'Linux课程',
        //     simpleDesc: '了解Linux发展历史、Linux的各种发行版本。主要讲解如何在VMware中的安装Linux (Centos7) 、远程登录Linux、用户和用户组管理、系统目录、文件权限与目录管理、磁盘管理、Linux防火墙、vim编辑器等; Linux中安装软件方式，安装JDK、Tomcat、MySQL等常用软件。<br/>能够轻松学会在Linux CentOS7上安装Redis (包括单机版、主从版、哨兵版、集群版)以及使用Redis进行项目开发。',
        //   },
        //   {
        //     color: 'purple darken-1',
        //     icon: 'mdi-domino-mask',
        //     title: 'Redis5.0.X',
        //     simpleDesc: '了解NOSQL概念、NoSQL数据库种类。讲解Redis的基本概念、优势以及5.0的新特性。详细讲解Redis数据类型、基本命令、Redis的主从复制模式、哨兵模式、集群模式的安装与使用、事务、RDB和AOF的持久化机制、订阅与发布。<br/>能够轻松学会在Linux CentOS7上安装Redis(包括单机版、主从版、哨兵版、集群版)以及使用Redis进行项目开发。',
        //   },
        //   {
        //     color: 'red lighten-1',
        //     icon: 'mdi-plus-thick',
        //     title: 'Quartz',
        //     simpleDesc: '详细讲解Java定时调度框架Quartz的基本概念、原理，Quartz核心API以及如何使用这些API实现定时调度功能。详细讲解Quartz的集群方案。<br/>掌握Quartz的就基本概念，使用Quartz进行项目开发，实现项目中作业调度。',
        //   },
        //   {
        //     color: 'pink lighten-2',
        //     icon: 'mdi-bell-circle',
        //     title: 'SpringBoot 2.0',
        //     simpleDesc: '详细讲解SpringBoot四大核心组成，SpringBoot Stater原理，SpringBoot的热部署, SpringBoot Admin, SpringBoot整合数据持久层(针对HikariCP和Druid两种数据库连接池)、多数据源、事务管理，SpringBoot整合新一代模板引擎Thymeleaf, SpringBoot与其它各种框架的整合(如缓存Redis、RPC框架Dubbo消息中间件ActiveMQ等等) <br/>SpringBoot快速开发web项目，能够自己实现符合自己业务逻辑SpringBoot Starter,掌握SpringBoot整合其它框架的思路。',
        //   },
        //   {
        //     color: 'grey darken-3',
        //     icon: 'mdi-diamond-stone',
        //     title: 'SpringCloud',
        //     simpleDesc: '讲解分布式、SOA、微服务架构概念以及web采构演变过程。SpringCloud的介绍、SpringCloud各种组件的作用，搭建注册中心Eureka进行服务注册与发现、使用Zuul搭建微服务网关、使用Ribbon实现负载均衡、Ribbon负载均衡策略类型，使用Hystrix断断路器实现服务的容错，使用声明式Http客户端Feign进行服务调用、配置中心。<br/>熟练掌握SringCloud各种组件的作用以及组件之间的关系，能够熟练搭建微服务项目，掌握每个服务的作用以及各个服务之间的关系，学会使用SpringCloud快速开发web微服务项目。',
        //   },
        //   // {
        //   //   color: 'red lighten-2',
        //   //   icon: 'mdi-star',
        //   //   title: 'Java核心编程技术 Core Java',
        //   //   simpleDesc: 'JAVA的历史以及应用，JAVA的优势、环境的搭建、基本数据类型、流程控制循环、深入讲解运算符以及运算符的高级应用、数组的基本应用及数组的赋值排序及多维数组....',
        //   //   details: '&emsp;&emsp;基础部分：<br/>&emsp;&emsp;&emsp;JAVA的历史以及应用，JAVA的优势、环境的搭建、基本数据类型、流程控制循环、深入讲解运算符以及运算符的高级应用、数组的基本应用及数组的赋值排序及多维数组、面向对象特征(封装、继承、多态)、方法重载覆盖、构造方法、参数传递、访问修饰符、抽象类、内部类、接口、异常处理。<br/><br/>&emsp;&emsp;常用类及接口：<br/>&emsp;&emsp;&emsp;Object、 String、 Date、DateFormat及SimpleDateFormat类、<br/>&emsp;&emsp;File、Properties、Collections、 Enumeration 、Iterator 。<br/><br/>&emsp;&emsp;常用设计模式：<br/>&emsp;&emsp;&emsp;工厂模式、 单例模式、策略模式、观察者模式、装饰模式、代理及动态代理模式、模板方法模式等模式的原理及在实际应用的中的案例。<br/><br/>&emsp;&emsp;JAVA集合框架 （JCF）：<br/>&emsp;&emsp;&emsp;深入解析每种集合类型的实现以及底层数据结构,包括单值类型集合以及键值对集合。<br/>&emsp;&emsp;Collection接口  List  ArrayList  LinkedList Vector Stack　HashSet   SortedSet   TreeSet<br/>&emsp;&emsp;&emsp;Map 接口 HashMap  TreeMap<br/>&emsp;&emsp;线程：<br/>&emsp;&emsp;线程和进程、多线程、继承 Thread 类创建线程类、实现 Runnable 接口创建线程类、使用 Callable和 Future 创建线程、创建线程的三种方式对比、线程的5大状态延伸7大状态、线程的等待sleep、join、线程安全问题、同步代码块、同步方法、死锁及解决方案、线程通信、Doug Lea实现并发包当中的线程池、等待队列和线程池的区别,java 7新增的 ForkJoinPool、ThreadLocal 类、以及并发包当中支持多线程并发操作的集合如ConcurrentHashMap。<br/><br/>&emsp;&emsp;IO：<br/>&emsp;&emsp;&emsp;文件的基本操作，文件的查找与过滤、字符流、 字节流、桥转换器。【该部分会详解23钟流的用法及实际使用时的陷阱与大坑】<br/><br/>&emsp;&emsp;Socket网络编程：<br/>&emsp;&emsp;&emsp;网络基础知识、ip地址和端口号、使用 InetAddress 、使用 UrlDecoder 和 UrlEncoder、使用 URL 和 URLConnection、TCP 协议基础 、使用 ServerSocket 创建 Tcp 服务器端、使用 Socket 进行通信、加入多线程、多线程下载、多线程访问文件等。<br/><br/>&emsp;&emsp;反射：<br/>&emsp;&emsp;&emsp;反射（Reflection）内省（Introspector）以及对内省的封装操作JAVABEAN的组件BeanUtils详解。包括反射的基本信息、Class类的理解、通过Class获得类中的属性和方法、通过反射实现Spring的IOC、通过反射模仿实现Hibernate的Session、反射的封装等。',
        //   // },
        //   // {
        //   //   color: 'indigo',
        //   //   icon: 'mdi-buffer',
        //   //   title: 'Spring SpringCloud SpringBoot MyBatis Hibernate',
        //   //   simpleDesc: '企业级开发技术学习实战，讲解分布式、SOA、微服务架构概念以及web架构演变过程。SpringCloud的介绍、SpringCloud各种组件的作用，服务注册与发现、服务网关、负载均衡、断路器、配置中心...',
        //   //   details: '&emsp;&emsp;SpringCloud:<br/>&emsp;&emsp;&emsp;讲解分布式、SOA、微服务架构概念以及web架构演变过程。SpringCloud的介绍、SpringCloud各种组件的作用，搭建注册中心Eureka进行服务注册与发现、使用Zuul搭建微服务网关、使用Ribbon实现负载均衡、Ribbon负载均衡策略类型，使用Hystrix断路器实现服务的容错，使用声明式Http客户端Feign进行服务调用、配置中心；<br/><br/>&emsp;&emsp;Spring:<br/>&emsp;&emsp;&emsp;Spring概述、快速入门、IOC容器概述、在IOC容器中装配bean、IOC容器高级主题、Spring AOP基础、基于@aspectj和schema的AOP、Spring对dao的支持、Spring的事务管理、整合ORM框架<br/><br/>&emsp;&emsp;MyBatis:<br/>&emsp;&emsp;&emsp;MyBATIS的流程及原理、MyBATIS入门、安装和配置MyBATIS、使用映射语句、执行非查询语句、使用高级查询技术、事务、使用动态SQL、使用高速缓存提高性能、MyBATIS数据访问对象、MyBatis多表关联。<br/><br/>&emsp;&emsp;Hibernate:<br/>&emsp;&emsp;&emsp;Java 对象持久化技术概述、第一个Hibernate应用、对象-关系映射基础、映射对象标识符、通过Hibernate操纵对象、映射组成关系、Hibernate的映射类型、映射继承关系、映射值类型集合、映射实体关联关系、映射一对多关联关系、映射一对一关联关系、映射多对多关联关系、Hibernate的检索策略、Hibernate的检索方式、Hibernate高级配置、管理Hibernate的二级缓存、管理Session和实现对话。',
        //   // },
        //   // {
        //   //   color: 'purple darken-1',
        //   //   icon: 'mdi-book-variant',
        //   //   title: '前端流行技术',
        //   //   simpleDesc: 'H5、CSS3、ECMAScript 2015语法新特性及应用场景、Webpack打包技术、NPM包管理工具、Vue2、Vue3基础、路由、Vuex、基于Promise的前后台交互技术、Mock.js、Vue组件化、Vue+ElementUI企业级整合开发',
        //   //   details: '&emsp;&emsp;H5 CSS3<br/>&emsp;&emsp;&emsp;前端基础技术，编写网页、样式布局<br/><br/>&emsp;&emsp;ECMAScript 2015：<br/>&emsp;&emsp;&emsp;熟悉基础JS语法，学习ES5及ES6语法新特性：变量声明、属性访问、解构赋值、模板字符串、Promise、新的对象属性和方法。<br/><br/>&emsp;&emsp;NPM WebPack：<br/>&emsp;&emsp;&emsp;前端工程化，包管理及打包工具的配置与使用<br/><br/>&emsp;&emsp;Vue：<br/>&emsp;&emsp;&emsp;Vue技术讲解：声明式渲染、条件循环、组件化、模板语法、计算属性、侦听器，核心插件Vue Router（路由）、Vuex状态管理。<br/><br/>&emsp;&emsp;ElementUI：<br/>&emsp;&emsp;&emsp;企业级前端开发组件库学习与实际项目开发演练。',
        //   // },
        //   // {
        //   //   color: 'green lighten-1',
        //   //   icon: 'mdi-airballoon',
        //   //   title: '关系型数据库 MySQL Oracle',
        //   //   simpleDesc: 'Oracle Mysql等关系型数据库分析讲解与实践，学习DDL、DML、索引、函数、多表连接、数据分发与统计SQL语句',
        //   //   details: '&emsp;&emsp;该部分主要是以ORACLE 和MySQL为载体，详细讲解数据库的内容。<br/>&emsp;&emsp;&emsp;主要包括ORACLE的下载及安装、ANSI-SQL的组成部分[DDL DML DQL TCL DCL]等标准SQL的基本操作、ORACLE的表空间、实例的创建及应用、ORACLE中的函数：单行【字符函数、数值函数、日期函数、转换函数】、多行函数【max\\min\\count\\sum\\avg】 、ORACLE中的分组、多表连接、子查询、使用rowID删除重复记录、使用rownum分页、行转列、列转行、数据分发与统计、视图索引序列等。<br/><br/>存储过程、触发器等实际案例的应用。包括 备份表、自动添加主键等案例。<br/><br/>&emsp;&emsp;XML技术<br/>&emsp;&emsp;&emsp;XML格式、组成部分、XML DTD、XML的解析：DOM解析 SAX解析、DOM4J、JDOM的解析等<br/><br/>&emsp;&emsp;JDBC 技术<br/>&emsp;&emsp;&emsp;JDBC的背景、JDBC的流程、数据源DataSource、数据库连接池组件 DBCP /C3P0/druid等、DAO模式的应用、JDBC控制事务、对JDBC的封装组件DBUtils等。',
        //   // },
        //   // {
        //   //   color: 'deep-orange darken-1',
        //   //   icon: 'mdi-airballoon',
        //   //   title: '项目开发与部署实战',
        //   //   simpleDesc: '项目开发环境、Linux部署环境教学与模拟，版本控制工具Git、SVN学习与实战',
        //   //   details: '&emsp;&emsp;git课程<br/>&emsp;&emsp;&emsp;主要讲解CVS（版本控制工具）发展，详细讲解分布式版本控制工具Git在企业中的应用，包括Git的安装配置、Git命令行操作、Git的三大区域、版本回退撤销等操作、分支管理、标签管理、远程仓库、工作流。GitHub注册与配置，如何使用GitHub进行协同开发，如何为开源项目贡献代码。详细讲解在IDE（IDEA\\Eclipse）中如何使用Git进行版本管理。<br/><br/>&emsp;&emsp;Linux课程：<br/>&emsp;&emsp;&emsp;了解Linux发展历史、Linux的各种发行版本。主要讲解如何在VMware中的安装Linux（Centos7）、远程登录Linux、用户和用户组管理、系统目录、文件权限与目录管理、磁盘管理、Linux防火墙、vim编辑器等；Linux中安装软件方式，安装JDK、Tomcat、MySQL等常用软件。',
        //   // }
        // ],
      }
    },
    components: {
    },
    mounted(){

    }
  }
</script>



// WEBPACK FOOTER //
// src/page/course/course.vue